import { createApp } from 'vue'
import App from './App.vue'
//element-plus 组件库引入
import ElementPlus from 'element-plus'
// 本地化CSS  REM 处理
import './assets/css/element-puls.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// 路由
import router from './router'
//引入 状态管理 vuex 配置文件
import store from './store/index.js'
//公用
import './assets/css/public.css'
import main from './utils/main.js'
// 创建并挂载根实例
const app = createApp(App);
app.config.globalProperties.$main = main;
app.use(ElementPlus, {
    locale: zhCn,
});
app.use(router);
app.use(store)
app.mount('#app')
